<div class="dialog">
  <h2 mat-dialog-title class="dialog-title">{{ variables?.editInitialCost }}</h2>
  <mat-dialog-content>
    <form [formGroup]="formGroup">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ variables?.initialCost }}</mat-label>
        <input matInput type="number" formControlName="amountCtrl" min="0" />
        <span matTextPrefix>€&nbsp;</span>
        <mat-error *ngIf="amountCtrl?.hasError('required')">
          {{ variables?.requiredField }}
        </mat-error>
        <mat-error *ngIf="amountCtrl?.hasError('min')">
          {{ variables?.valueMustBePositive }}
        </mat-error>
      </mat-form-field>
    </form>
  </mat-dialog-content>
  <div class="dialog-box-s">
    <mat-dialog-actions class="button-group">
      <app-button typeBtn="secondary" color="red" textColor="white" message="{{ variables?.cancel }}" (click)="cancel()"></app-button>
      <app-button typeBtn="primary" message="{{ variables?.save }}" [disabled]="formGroup.invalid" (click)="save()"></app-button>
    </mat-dialog-actions>
  </div>
</div>
